export default {
    workspaces: {
        nivel: "intermedio",
        cuando: ["Escritorios virtuales para equipos remotos.", "Datos que no deben salir de AWS.", "Entregar equipos estandarizados."],
        evita: ["Una sola aplicación: AppStream.", "Pocos usuarios con equipos propios."],
        alt: [["appstream", "Solo aplicaciones, no escritorio."]],
        cobro: "Por mes o por hora según el modo (siempre encendido o autodetención), más el tamaño del paquete.",
        con: ["directory", "vpc", "iam"],
        quiz: { p: "¿Dónde viven los archivos del usuario en WorkSpaces?", o: ["En AWS, no en el equipo local", "En el celular", "En un USB"], c: 0, e: "Solo se transmite la pantalla." },
    },
    appstream: {
        nivel: "avanzado",
        cuando: ["Entregar una aplicación de escritorio por navegador.", "Aplicaciones antiguas sin instalar.", "Aplicaciones que necesitan GPU."],
        evita: ["Escritorios completos: WorkSpaces."],
        alt: [["workspaces", "Escritorio completo."]],
        cobro: "Por hora de cada instancia de la flota según el modo y por usuario según el plan.",
        con: ["directory", "vpc", "s3"],
        quiz: { p: "¿Qué recibe el usuario de AppStream?", o: ["La imagen de la aplicación por streaming", "Un instalador", "Una factura"], c: 0, e: "La aplicación corre en AWS." },
    },
    connect: {
        nivel: "intermedio",
        cuando: ["Centro de atención de llamadas y chat en la nube.", "Menús de voz y bots.", "Pagar solo por lo usado."],
        evita: ["Atención ocasional por correo."],
        alt: [["lex", "Bots de conversación."], ["pinpoint", "Mensajes salientes."]],
        cobro: "Por minuto de uso (voz y chat) más los números telefónicos.",
        con: ["lex", "transcribe", "lambda", "s3"],
        quiz: { p: "¿Qué decide qué hacer con cada contacto?", o: ["El flujo de contacto", "La cola de impresión", "El balanceador"], c: 0, e: "Es el guion del contacto." },
    },
    ses: {
        nivel: "basico",
        cuando: ["Enviar correos de la aplicación (confirmaciones, recibos).", "Campañas de correo.", "Medir entregas y rebotes."],
        evita: ["Si no verificas tu dominio ni cuidas la reputación: tus correos irán a spam."],
        alt: [["pinpoint", "Campañas multicanal."], ["sns", "Notificaciones."]],
        cobro: "Por cada mil correos enviados y por adjuntos.",
        con: ["route53", "lambda", "sns", "cloudwatch"],
        quiz: { p: "¿Qué se recomienda configurar en el dominio para enviar correo?", o: ["SPF, DKIM y DMARC", "Solo un logo", "Un certificado SSL"], c: 0, e: "Autentican al remitente y protegen la reputación." },
    },
    pinpoint: {
        nivel: "intermedio",
        cuando: ["Campañas dirigidas por correo, SMS y notificaciones push.", "Segmentar por comportamiento.", "Medir aperturas y conversiones."],
        evita: ["Correos transaccionales simples: SES."],
        alt: [["ses", "Correo transaccional."], ["sns", "Notificaciones."]],
        cobro: "Por usuarios que se alcanzan al mes y por mensajes enviados según el canal.",
        con: ["ses", "sns", "s3"],
        quiz: { p: "¿Qué es un segmento en Pinpoint?", o: ["Un grupo de usuarios con algo en común", "Un tipo de disco", "Una región"], c: 0, e: "Define a quién va la campaña." },
    },
    workmail: {
        nivel: "basico",
        cuando: ["Correo y calendario empresarial administrados.", "Compatible con Outlook.", "Cifrado y control de acceso integrados."],
        evita: ["Si ya usas Microsoft 365 o Google Workspace."],
        alt: [["ses", "Solo envío desde aplicaciones."]],
        cobro: "Por usuario al mes según el plan elegido.",
        con: ["ses", "kms", "directory"],
        quiz: { p: "¿Con qué clientes es compatible WorkMail?", o: ["Outlook y clientes con protocolos estándar", "Solo uno propio", "Ninguno"], c: 0, e: "Usa protocolos estándar y ofrece acceso web." },
    },
    iotcore: {
        nivel: "intermedio",
        cuando: ["Conectar sensores y máquinas de forma segura.", "Recibir datos de millones de dispositivos.", "Enviar órdenes a los dispositivos."],
        evita: ["Cómputo local sin conexión: Greengrass."],
        alt: [["greengrass", "Lógica en el borde."], ["kinesis", "Flujos de datos."]],
        cobro: "Por mensajes, por minutos de conexión y por acciones de reglas.",
        con: ["lambda", "dynamodb", "s3", "timestream", "greengrass"],
        quiz: { p: "¿Cómo se autentica un dispositivo en IoT Core?", o: ["Con un certificado X.509", "Con un correo", "Con una contraseña compartida por todos"], c: 0, e: "Cada dispositivo tiene su identidad." },
        falla: { nodo: 1, texto: "Si el dispositivo pierde conexión, el broker no recibe sus mensajes; con sesiones persistentes y mensajes retenidos, el dispositivo recupera lo pendiente al reconectar." },
    },
    greengrass: {
        nivel: "avanzado",
        cuando: ["Procesar datos en el dispositivo aunque no haya red.", "Responder en milisegundos en el borde.", "Reducir el envío de datos a la nube."],
        evita: ["Dispositivos que solo envían datos: IoT Core basta."],
        alt: [["iotcore", "Conectividad con la nube."]],
        cobro: "Por dispositivo core activo al mes (con capa gratuita); se cobran los servicios que use.",
        con: ["iotcore", "lambda", "s3"],
        quiz: { p: "¿Qué permite Greengrass?", o: ["Ejecutar lógica en el dispositivo aun sin conexión", "Guardar facturas", "Crear redes"], c: 0, e: "Sincroniza con AWS cuando hay red." },
    },
    mediaconvert: {
        nivel: "intermedio",
        cuando: ["Convertir videos a varios formatos y calidades.", "Preparar contenido para streaming.", "Procesos por lote a escala."],
        evita: ["Video en vivo: MediaLive."],
        alt: [["medialive", "Video en vivo."]],
        cobro: "Por minuto de video de salida según la resolución y las funciones usadas.",
        con: ["s3", "cloudfront", "lambda"],
        quiz: { p: "¿Qué hace MediaConvert?", o: ["Transcodifica archivos de video", "Transmite en vivo", "Edita fotos"], c: 0, e: "Es conversión de video bajo demanda." },
    },
    medialive: {
        nivel: "avanzado",
        cuando: ["Transmisiones en vivo (eventos, deportes, TV).", "Varias calidades para cada espectador.", "Integrar con MediaPackage y CloudFront."],
        evita: ["Archivos ya grabados: MediaConvert."],
        alt: [["mediaconvert", "Para archivos ya grabados, no para señal en vivo."], ["ivs", "Transmisión en vivo simple."]],
        cobro: "Por hora de canal en ejecución según su configuración.",
        con: ["cloudfront", "s3", "mediaconvert"],
        quiz: { p: "¿Qué recibe un input de MediaLive?", o: ["La señal de video en vivo", "Una factura", "Un correo"], c: 0, e: "Por RTMP, SRT u otros protocolos." },
    },
    ivs: {
        nivel: "basico",
        cuando: ["Transmisión en vivo de baja latencia lista para usar.", "Eventos y comunidades con chat.", "Sin armar la infraestructura de video."],
        evita: ["Control fino del pipeline de video: MediaLive."],
        alt: [["medialive", "Más control."]],
        cobro: "Por hora de entrada de video y por hora de video entregado a los espectadores.",
        con: ["cloudfront", "s3"],
        quiz: { p: "¿Qué autoriza a emitir a un canal IVS?", o: ["La Stream Key", "El nombre del canal", "La región"], c: 0, e: "Es una clave secreta del canal." },
    },
};
